<template>
	<!-- <div v-hotkey="keymap"> -->
	<div>
		<div class="favorite_wrap">
			<div class="favorite_title">
				<h2>Favorites Menu</h2>
				<!-- <a href="/basic_info/settings" id="nav_li_37" class="favorite_setting">Setting</a> -->
				<router-link to="/basic_info/settings" class="favorite_setting">Setting</router-link>
			</div>

			<ul>
				<template v-if="fav_menus.length == 0">
					<div class="favorite_text">
						<p>Please add<br />your favorite menu.</p>
					</div>
				</template>
				<template v-else>
					<li v-for="fm in fav_menus" v-bind:key="fm.path">
						<router-link :to="fm.path">{{ fm.name }}</router-link>
					</li>
				</template>

				<li v-if="stock_changed">
					<router-link to="/item/item_master?stock_changed_yn=Y" id="nav_li_1">
						<strong>
							<font color="red">Stock Changed!!!</font>
						</strong>
					</router-link>
				</li>
			</ul>
		</div>

		<nav id="left_accordian_nav" class="left_nav">
			<h3 name="m_100"><em class="left_icon02">item</em><a href="javascript:;">Item</a></h3>
			<div class="nav_inner" gnb_name="m_100">
				<ul>
					<li v-if="visible('/item/item_master')"><router-link to="/item/item_master" :class="{ on: selectedMenu == 'nav_li_item_master' }">Item Master</router-link></li>
					<li v-if="visible('/item/item_class')">
						<router-link to="/item/item_class" :class="{ on: selectedMenu == 'nav_li_item_class' }">Item {{ headers.class }}</router-link>
					</li>
					<li v-if="visible('/item/inventory_history')"><router-link to="/item/inventory_history" :class="{ on: selectedMenu == 'nav_li_inventory_history' }">Inventory History</router-link></li>
					<li v-if="visible('/item/inventory_status')"><router-link to="/item/inventory_status" :class="{ on: selectedMenu == 'nav_li_inventory_status' }">Inventory Status</router-link></li>
					<li v-if="visible('/item/cost_adjust')"><router-link to="/item/cost_adjust" :class="{ on: selectedMenu == 'nav_li_cost_adjust' }">Cost Adjustment</router-link></li>
					<li v-if="visible('/item/stock_adjust')"><router-link to="/item/stock_adjust" :class="{ on: selectedMenu == 'nav_li_stock_adjust' }">Stock Adjustment</router-link></li>
					<li v-if="visible('/item/inventory_adjust')"><router-link to="/item/inventory_adjust" :class="{ on: selectedMenu == 'nav_li_inventory_adjust' }">Inventory Adjustment</router-link></li>
					<li v-if="visible('/item/inventory_transaction')"><router-link to="/item/inventory_transaction" :class="{ on: selectedMenu == 'nav_li_inventory_transaction' }">Inventory Transaction</router-link></li>
					<li v-if="visible('/item/repack')"><router-link to="/item/repack" :class="{ on: selectedMenu == 'nav_li_repack' }">Repacking / Subdivision</router-link></li>
					<li v-if="visible('/item/inventory_counting')"><router-link to="/item/inventory_counting" :class="{ on: selectedMenu == 'nav_li_inventory_counting' }">Inventory Counting</router-link></li>
					<li v-if="visible('/item/label_print')"><router-link to="/item/label_print" :class="{ on: selectedMenu == 'nav_li_label_print' }">Label Print</router-link></li>
					<li v-if="visible('/item/item_list')"><router-link to="/item/item_list" :class="{ on: selectedMenu == 'nav_li_item_list' }">Item List w/ UPC & Inventory</router-link></li>
					<li v-if="visible('/item/item_block')">
						<router-link to="/item/item_block" :class="{ on: selectedMenu == 'nav_li_item_block' }">Block {{ headers.class }} in Sales Order</router-link>
					</li>
					<li v-if="visible('/item/item_designation')">
						<router-link to="/item/item_designation" :class="{ on: selectedMenu == 'nav_li_item_desigation' }">Item Designation</router-link>
					</li>
					<li v-if="visible('/item/user_defined_group')"><router-link to="/item/user_defined_group" :class="{ on: selectedMenu === 'nav_li_user_defined_group' }">User Defined Group</router-link></li>
					<li v-if="visible('/item/stock_vs_reorder')"><router-link to="/item/stock_vs_reorder" :class="{ on: selectedMenu === 'nav_li_stock_vs_reorder' }">Stock vs. Reorder</router-link></li>
					<li v-if="visible('/item/shopify')"><router-link to="/item/shopify" :class="{ on: selectedMenu == 'nav_li_shopify_item' }">Shopify</router-link></li>
				</ul>
			</div>

			<h3 name="m_200"><em class="left_icon03">Purchase</em><a href="javascript:;">Purchase</a></h3>
			<div class="nav_inner" gnb_name="m_200">
				<ul>
					<li v-if="visible('/purchase/po_main')"><a href="/purchase/po_main" :class="{ on: selectedMenu == 'nav_li_po_main' }">Purchase Order</a></li>
					<li v-if="visible('/purchase/shipment_main')"><a href="/purchase/shipment_main" :class="{ on: selectedMenu == 'nav_li_shipment_main' }">Shipment</a></li>
					<li v-if="visible('/purchase/preReceiving')"><a href="/purchase/preReceiving" :class="{ on: selectedMenu == 'nav_li_PreReceiving' }">Pre Receiving List</a></li>
					<li v-if="visible('/purchase/receivedList')"><a href="/purchase/receivedList" :class="{ on: selectedMenu == 'nav_li_receivedList' }">Received List</a></li>
					<li v-if="visible('/purchase/receivedGoods')"><a href="/purchase/receivedGoods" :class="{ on: selectedMenu == 'nav_li_receivedGoods' }">Received Goods</a></li>
					<li v-if="visible('/purchase/on_board_schedule')"><a href="/purchase/on_board_schedule" :class="{ on: selectedMenu == 'nav_li_onBoardSchedule' }">On B. / Rcvd. Schedule</a></li>
					<li v-if="visible('/purchase/on_order_detail')"><a href="/purchase/on_order_detail" :class="{ on: selectedMenu == 'nav_li_on_order_detail' }">On Order Detail</a></li>
					<li v-if="visible('/purchase/slip')"><router-link to="/purchase/slip" :class="{ on: selectedMenu == 'nav_li_slip' }">Slip</router-link></li>
					<li v-if="visible('/purchase/last_shipment_price')"><router-link to="/purchase/last_shipment_price" :class="{ on: selectedMenu == 'nav_li_last_shipment_price' }">Last Shipment Price</router-link></li>
				</ul>
			</div>

			<h3 name="m_300"><em class="left_icon04">Sales</em><a href="javascript:;">Sales</a></h3>
			<div class="nav_inner" gnb_name="m_300">
				<ul>
					<li v-if="visible('/sales/so_main')"><router-link to="/sales/so_main" :class="{ on: selectedMenu == 'nav_li_so_main' }">Sales Order</router-link></li>
					<li v-if="visible('/sales/wh_return')"><router-link to="/sales/wh_return" :class="{ on: selectedMenu == 'nav_li_wh_return' }">Warehouse Return</router-link></li>
					<li v-if="visible('/sales/request_price')"><router-link to="/sales/request_price" :class="{ on: selectedMenu == 'nav_li_request_price' }">Approved Price</router-link></li>
					<li v-if="visible('/sales/packing_status')"><router-link to="/sales/packing_status" :class="{ on: selectedMenu == 'nav_li_packing_status' }">Packing Status</router-link></li>
					<li v-if="visible('/sales/pickup')"><router-link to="/sales/pickup" :class="{ on: selectedMenu == 'nav_li_pickup' }">Pick Up for Packing</router-link></li>
					<li v-if="visible('/sales/boxing')"><router-link to="/sales/boxing" :class="{ on: selectedMenu == 'nav_li_boxing' }">Packing Box</router-link></li>
					<li v-if="visible('/sales/warehouse_memo')"><router-link to="/sales/warehouse_memo" :class="{ on: selectedMenu == 'nav_li_warehouse_memo' }">Warehouse Memo</router-link></li>
					<li v-if="visible('/sales/invoice_main')"><router-link to="/sales/invoice_main" :class="{ on: selectedMenu == 'nav_li_invoice_main' }">Invoice</router-link></li>
					<li v-if="visible('/sales/back_order')"><router-link to="/sales/back_order" :class="{ on: selectedMenu == 'nav_li_back_order' }">Back Order</router-link></li>
					<li v-if="visible('/sales/call_tag')"><router-link to="/sales/call_tag" :class="{ on: selectedMenu == 'nav_li_call_tag' }">Call Tag</router-link></li>
					<li v-if="visible('/sales/sample')"><router-link to="/sales/sample" :class="{ on: selectedMenu == 'nav_li_sample' }">Sample</router-link></li>
					<!-- <li v-if="visible('/sales/sample_pickup')"><router-link to="/sales/sample_pickup" :class="{ on: selectedMenu == 'nav_li_sample_pickup' }">Sample Pick Up</router-link></li> -->
					<li v-if="visible('/sales/retail/main')"><router-link to="/sales/retail/main" :class="{ on: selectedMenu == 'nav_li_retail' }">Retail Store</router-link></li>
					<li v-if="visible('/sales/shopify')"><router-link to="/sales/shopify" :class="{ on: selectedMenu == 'nav_li_shopify_order' }">Shopify</router-link></li>
					<li v-if="visible('/sales/delayed_invoice')"><router-link to="/sales/delayed_invoice" :class="{ on: selectedMenu == 'nav_li_delayed_invoice' }">Delayed SO / Invoice</router-link></li>
					<li v-if="visible('/sales/promotion')"><router-link to="/sales/promotion" :class="{ on: selectedMenu == 'nav_li_promotion' }">Promotion</router-link></li>
				</ul>
			</div>

			<h3 name="m_400" v-show="submenuCount('/payment/') > 0"><em class="left_icon05">AP</em><a href="javascript:;">AP</a></h3>
			<div class="nav_inner" gnb_name="m_400" v-show="submenuCount('/payment/') > 0">
				<ul>
					<li v-if="visible('/payment/ap_main')"><a href="/payment/ap_main" :class="{ on: selectedMenu == 'nav_li_ap_main' }">Accounts Payable</a></li>
					<li v-if="visible('/payment/ap_history')"><a href="/payment/ap_history" :class="{ on: selectedMenu == 'nav_li_ap_history' }">AP History</a></li>
					<li v-if="visible('/payment/ap_reverse')"><a href="/payment/ap_reverse" :class="{ on: selectedMenu === 'nav_li_ap_reverse' }">Payment Reverse</a></li>
				</ul>
			</div>

			<h3 name="m_500"><em class="left_icon06">AR</em><a href="javascript:;">AR</a></h3>
			<div class="nav_inner" gnb_name="m_500">
				<ul>
					<li v-if="visible('/receipt/ar_main')"><a href="/receipt/ar_main" :class="{ on: selectedMenu == 'nav_li_ar_main' }">Accounts Receivable</a></li>
					<li v-if="visible('/receipt/ar_history')"><a :href="$session.get('ar_history_uri') ? $session.get('ar_history_uri') : '/receipt/ar_history'" :class="{ on: selectedMenu == 'nav_li_ar_history' }">AR History</a></li>
					<li v-if="visible('/receipt/ar_check')"><a href="/receipt/ar_check" :class="{ on: selectedMenu == 'nav_li_ar_check' }">Check Settlement</a></li>
					<li v-if="visible('/receipt/ar_reverse')"><a href="/receipt/ar_reverse" :class="{ on: selectedMenu === 'nav_li_ar_reverse' }">Payment Reverse</a></li>
					<li v-if="visible('/receipt/bounceList')"><a href="/receipt/bounceList" :class="{ on: selectedMenu === 'nav_li_bounceList' }">Bounce List</a></li>
				</ul>
			</div>

			<h3 name="m_600"><em class="left_icon07">Daily Closing</em><a href="javascript:;">Daily Closing</a></h3>
			<div class="nav_inner" gnb_name="m_600">
				<ul>
					<li v-if="visible('/dc/login_id_scan')"><a href="/dc/login_id_scan" :class="{ on: selectedMenu == 'nav_li_login_id_scan' }">Login ID Scan</a></li>
					<!-- <li><a href="/daily_closing/driver_report" id="nav_li_16">Driver's Report</a></li>
					<li><a href="/daily_closing/salesman_report" id="nav_li_17">Salesman's Report</a></li>
					<li><a href="/daily_closing/payment_checklist" id="nav_li_18">Payment Check List</a></li> -->
				</ul>
			</div>

			<h3 name="m_700"><em class="left_icon08">Report</em><a href="javascript:;">Report</a></h3>
			<div class="nav_inner" gnb_name="m_700">
				<ul>
					<li v-if="user.super_admin_yn == 'Y'">
						<!-- <li v-if="visible('/report/dashboard')"> -->
						<router-link to="/report/nlquery" :class="{ on: selectedMenu === 'nav_li_nlquery' }">AI Query</router-link>
					</li>
					<li v-if="visible('/report/dashboard')">
						<router-link to="/report/dashboard" :class="{ on: selectedMenu === 'nav_li_dashboard' }">Dashboard</router-link>
					</li>
					<li v-if="visible('/report/arAging')">
						<router-link to="/report/arAging" :class="{ on: selectedMenu === 'nav_li_arAging' }">AR Aging</router-link>
					</li>
					<li v-if="visible('/report/receiptType')">
						<router-link to="/report/receiptType" :class="{ on: selectedMenu === 'nav_li_receiptType' }">Receipt Status By Type</router-link>
					</li>
					<li v-if="visible('/report/balanceBySalesGroup')">
						<router-link to="/report/balanceBySalesGroup" :class="{ on: selectedMenu === 'nav_li_arBalanceBySalesGroup' }">AR Balance By SalesGroup</router-link>
					</li>
					<li v-if="visible('/report/ar_balance_for_bank')">
						<router-link to="/report/ar_balance_for_bank" :class="{ on: selectedMenu === 'nav_li_ar_balance_for_bank' }">AR Balance For Bank</router-link>
					</li>
					<li v-if="visible('/report/ar_balance_for_cpa')">
						<router-link to="/report/ar_balance_for_cpa" :class="{ on: selectedMenu === 'nav_li_ar_balance_for_cpa' }">AR Balance For CPA</router-link>
					</li>
					<li v-if="visible('/report/packingStatus')">
						<router-link to="/report/packingStatus" :class="{ on: selectedMenu === 'nav_li_packingStatus' }">Packing Status</router-link>
					</li>
					<li v-if="visible('/report/immediatePayment')">
						<router-link to="/report/immediatePayment" :class="{ on: selectedMenu === 'nav_li_immediatePayment' }">Immediate Payment</router-link>
					</li>
					<li v-if="visible('/report/salesTemplate')">
						<router-link to="/report/salesTemplate" :class="{ on: selectedMenu === 'nav_li_salesTemplate' }">Sales Template(Monthly)</router-link>
					</li>
					<li v-if="visible('/report/salesTemplate/yearly')">
						<router-link to="/report/salesTemplate/yearly" :class="{ on: selectedMenu === 'nav_li_salesTemplateYearly' }">Sales Template(Yearly)</router-link>
					</li>
					<li v-if="visible('/report/salesReturnReceipt')">
						<router-link to="/report/salesReturnReceipt" :class="{ on: selectedMenu === 'nav_li_salesReturnReceipt' }">SalesReturnReceiptReport</router-link>
					</li>
					<li v-if="visible('/report/annualSalesArSummary')">
						<router-link to="/report/annualSalesArSummary" :class="{ on: selectedMenu === 'nav_li_annualSalesArSummary' }">Annual Sales &amp; AR Summary</router-link>
					</li>
					<li v-if="visible('/report/salesByState')">
						<router-link to="/report/salesByState" :class="{ on: selectedMenu === 'nav_li_salesByState' }">Sales by State</router-link>
					</li>
					<li v-if="visible('/report/salesByCustomer')">
						<router-link to="/report/salesByCustomer" :class="{ on: selectedMenu === 'nav_li_salesByCustomer' }">Sales by Customer</router-link>
					</li>
					<li v-if="visible('/report/salesOrderList')">
						<router-link to="/report/salesOrderList" :class="{ on: selectedMenu === 'nav_li_salesOrder' }">Daily Sales Order</router-link>
					</li>
					<li v-if="visible('/report/vendorAnalyze/item')">
						<router-link to="/report/vendorAnalyze/item" :class="{ on: selectedMenu === 'nav_li_vendorAnalyzeItem' }">Vendor Analyze Item</router-link>
					</li>
					<li v-if="visible('/report/purchase_overview')">
						<router-link to="/report/purchase_overview" :class="{ on: selectedMenu === 'nav_li_purchase_overview' }">Purchase Overview</router-link>
					</li>
					<li v-if="visible('/report/selectPurchaseByVendor')">
						<router-link to="/report/selectPurchaseByVendor" :class="{ on: selectedMenu === 'nav_li_purchaseByVendor' }">Purchase by Vendor</router-link>
					</li>
					<li v-if="user.company_id == 'jc' && visible('/report/deliveryList')">
						<router-link to="/report/deliveryList" :class="{ on: selectedMenu === 'nav_li_deliveryList' }">Delivery List</router-link>
					</li>
					<li v-if="user.company_id == 'jc' && visible('/report/dailyTransactionSummary')">
						<router-link to="/report/dailyTransactionSummary" :class="{ on: selectedMenu === 'nav_li_dailyTransactionSummary' }">Daily Transaction Summary</router-link>
					</li>
					<li v-if="user.company_id == 'jc' && visible('/report/soOnOrderDetail')">
						<router-link to="/report/soOnOrderDetail" :class="{ on: selectedMenu === 'nav_li_soOnOrderDetail' }">Sales On Order Detail</router-link>
					</li>
					<li v-if="visible('/report/purchase_history_by_goods')">
						<router-link to="/report/purchase_history_by_goods" :class="{ on: selectedMenu === 'nav_li_purchase_history_by_goods' }">Purchase History by Goods</router-link>
					</li>
					<li v-if="visible('/report/annual_history_by_goods')">
						<router-link to="/report/annual_history_by_goods" :class="{ on: selectedMenu === 'nav_li_annual_history_by_goods' }">Annual History by Goods</router-link>
					</li>
					<li v-if="visible('/report/historical_sales_by_item')">
						<router-link to="/report/historical_sales_by_item" :class="{ on: selectedMenu === 'nav_li_historical_sales_by_item' }">Historical Sales by Item</router-link>
					</li>
					<li v-if="visible('/report/item_aging')">
						<router-link to="/report/item_aging" :class="{ on: selectedMenu === 'nav_li_item_aging' }">Item Aging</router-link>
					</li>
					<li v-if="visible('/report/item_inquiry')">
						<router-link to="/report/item_inquiry" :class="{ on: selectedMenu === 'nav_li_item_inquiry' }">Item Inquiry</router-link>
					</li>
					<li v-if="visible('/report/sales_overview')">
						<router-link to="/report/sales_overview" :class="{ on: selectedMenu === 'nav_li_sales_overview' }">Sales Overview</router-link>
					</li>
					<li v-if="visible('/report/sales_goods')">
						<router-link to="/report/sales_goods" :class="{ on: selectedMenu === 'nav_li_sales_goods' }">Sales Goods</router-link>
					</li>
					<li v-if="visible('/report/sales_goods_by_salesGroup')">
						<router-link to="/report/sales_goods_by_salesGroup" :class="{ on: selectedMenu === 'nav_li_sales_goods_by_salesGroup' }">Sales Goods by S.Group</router-link>
					</li>
					<li v-if="visible('/report/salesTopRecordClass')">
						<router-link to="/report/salesTopRecordClass" :class="{ on: selectedMenu === 'nav_li_salesTopRecordClass' }">Sales Top Record {{ headers.class }}</router-link>
					</li>
					<li v-if="visible('/report/salesTopRecordCustomer')">
						<router-link to="/report/salesTopRecordCustomer" :class="{ on: selectedMenu === 'nav_li_salesTopRecordCustomer' }">Sales Top Record Cust.</router-link>
					</li>
					<li v-if="visible('/report/scanned_SO_items')">
						<router-link to="/report/scanned_SO_items" :class="{ on: selectedMenu === 'nav_li_scanned_SO_items' }">Scanned S/O Items</router-link>
					</li>
					<li v-if="visible('/report/customer_list_with_no_certain_items')">
						<router-link to="/report/customer_list_with_no_certain_items" :class="{ on: selectedMenu === 'nav_li_customer_list_with_no_certain_items' }">Cust. w/o Certain Items</router-link>
						<!--						<router-link to="/report/no-certain-item-customer" :class="{ on: selectedMenu === 'nav_li_customer_list_with_no_certain_items' }">Cust. w/o Certain Items</router-link>-->
					</li>
					<li v-if="visible('/report/first_sale')">
						<router-link to="/report/first_sale" :class="{ on: selectedMenu === 'nav_li_first_sale' }">First Sale</router-link>
					</li>
					<li v-if="visible('/report/landingRates')">
						<router-link to="/report/landingRates" :class="{ on: selectedMenu === 'nav_li_landingRates' }">Landing Rates</router-link>
					</li>
					<li v-if="visible('/report/landingRegion')">
						<router-link to="/report/landingRegion" :class="{ on: selectedMenu === 'nav_li_landingRegion' }">Landing Region</router-link>
					</li>
					<li v-if="visible('/report/landingRegionGroup')">
						<router-link to="/report/landingRegionGroup" :class="{ on: selectedMenu === 'nav_li_landingRegionGroup' }">Landing Region Group</router-link>
					</li>
					<li v-if="visible('/report/approved/back-order')">
						<router-link to="/report/approved/back-order" :class="{ on: selectedMenu === 'nav_li_approved_back_order' }">Approved Back Order</router-link>
					</li>
					<li v-if="visible('/report/inventory-sheet')">
						<router-link to="/report/inventory-sheet" :class="{ on: selectedMenu === 'nav_li_inventory-sheet' }">Inventory Sheet</router-link>
					</li>
					<li v-if="visible('/report/repacking')">
						<router-link to="/report/repacking" :class="{ on: selectedMenu === 'nav_li_repacking' }">Item Repacking</router-link>
					</li>
					<li v-if="visible('/report/short_date')">
						<router-link to="/report/short_date" :class="{ on: selectedMenu === 'nav_li_short_date' }">Short Date</router-link>
					</li>
					<li v-if="visible('/report/packing_per_staff')">
						<router-link to="/report/packing_per_staff" :class="{ on: selectedMenu === 'nav_li_packing_per_staff' }">Packing Per Staff</router-link>
					</li>
					<li v-if="visible('/report/daily_sales_progress')">
						<router-link to="/report/daily_sales_progress" :class="{ on: selectedMenu === 'nav_li_daily_sales_progress' }">Daily Sales Progress</router-link>
					</li>
					<!--					<li>-->
					<!--					<li v-if="visible('/report/customer-statement')">-->
					<!--						<router-link to="/report/customer-statement" :class="{ on: selectedMenu === 'nav_li_customer_statement' }">Customer Statement</router-link>-->
					<!--					</li>-->

					<!--					<li v-if="visible('/report/no-certain-item-customer')">-->
					<li v-if="visible('/report/ar_notification_log')">
						<router-link to="/report/ar_notification_log" :class="{ on: selectedMenu === 'nav_li_ar_notification_log' }">AR Notification Log</router-link>
					</li>
					<li v-if="visible('/report/gps_log')">
						<router-link to="/report/gps_log" :class="{ on: selectedMenu === 'nav_li_gps_log' }">GPS Log</router-link>
					</li>
					<li v-if="user.user_id == 'argonet_admin'">
						<router-link to="/report/login_log" :class="{ on: selectedMenu == 'nav_li_login_log' }">Login Log</router-link>
					</li>
					<li v-if="visible('/report/mail-log')">
						<router-link :to="{ name: 'mailLog' }" :class="{ on: selectedMenu === 'nav_li_login_log' }">Mail Log</router-link>
					</li>
				</ul>
			</div>

			<h3 name="m_800"><em class="left_icon09">Partner</em><a href="javascript:void(0);">Partner</a></h3>
			<div class="nav_inner" gnb_name="m_800">
				<ul>
					<li v-if="visible('/partner/partner_main')">
						<router-link to="/partner/partner_main" :class="{ on: selectedMenu === 'nav_li_partner_main' }">Partner Main </router-link>
					</li>
					<li v-if="visible('/partner/partner_simple')">
						<router-link to="/partner/partner_simple" :class="{ on: selectedMenu === 'nav_li_partner_simple' }">Partner Info (Simple)</router-link>
					</li>
					<li v-if="visible('/partner/customer_main')">
						<router-link :to="{ name: 'customers' }" :class="{ on: selectedMenu === 'nav_li_customer_main' }">Customer Main </router-link>
					</li>
					<li v-if="user.company_id == 'newjigu' && visible('/partner/detail')">
						<input type="text" v-model="partner_code" style="margin-left:47px;width:140px;font-size:13px;" placeholder="Enter Partner Code" autofocus autocomplete="off" @keyup.enter="gotoPartner(partner_code)" @focus="$event.target.select()" />
					</li>
					<li v-if="visible('/sc/sc_main')">
						<router-link to="/sc/sc_main" :class="{ on: selectedMenu === 'nav_li_sc_main' }">Store Credit</router-link>
					</li>
					<li v-if="visible('/partner/vendor_main')">
						<router-link :to="{ name: 'vendors' }" :class="{ on: selectedMenu === 'nav_li_vendor_main' }">Vendor Main </router-link>
					</li>
				</ul>
			</div>

			<h3><em class="left_icon10">Basic Information</em><a href="javascript:;">Basic Information</a></h3>
			<div class="nav_inner" id="Basic Information">
				<ul>
					<!-- <li v-if="user.admin_yn == 'Y'"><router-link to="/basic_info/user" :class="{ on: selectedMenu == 'nav_li_user' }">User</router-link></li> -->
					<li v-if="user.admin_yn == 'Y' || visible('/basic_info/user')"><router-link to="/basic_info/user" :class="{ on: selectedMenu == 'nav_li_user' }">User</router-link></li>
					<li v-if="user.admin_yn == 'Y' || visible('/basic_info/salesgroup')"><router-link to="/basic_info/salesgroup" :class="{ on: selectedMenu == 'nav_li_salesgroup' }">Sales Group</router-link></li>
					<li v-if="user.admin_yn == 'Y' || visible('/basic_info/code') || user.color_code_mgmt || user.icc_code_mgmt">
						<router-link to="/basic_info/code" :class="{ on: selectedMenu == 'nav_li_code' }">Code</router-link>
					</li>
					<li v-if="user.admin_yn == 'Y'"><router-link to="/basic_info/zone" :class="{ on: selectedMenu == 'nav_li_zone' }">Zone</router-link></li>
					<li v-if="user.admin_yn == 'Y'"><router-link to="/basic_info/zipcode" :class="{ on: selectedMenu == 'nav_li_zipcode' }">Zipcode</router-link></li>
					<li v-if="user.admin_yn == 'Y'"><router-link to="/basic_info/shipment" :class="{ on: selectedMenu == 'nav_li_shipment' }">Shipment</router-link></li>
					<li v-if="(profile.use_pick_order == 'Y' || user.company_id == 'newjigu') && user.admin_yn == 'Y'">
						<router-link to="/basic_info/pick_order" :class="{ on: selectedMenu == 'nav_li_pick_order' }">Pick Order</router-link>
					</li>
					<li><router-link to="/basic_info/settings" :class="{ on: selectedMenu == 'nav_li_settings' }">Settings</router-link></li>
					<li v-if="visible('/basic_info/retail_setting')"><router-link to="/basic_info/retail_setting" :class="{ on: selectedMenu == 'nav_li_retail_setting' }">Retail Setting</router-link></li>
					<li v-if="user.super_admin_yn == 'Y'"><router-link to="/basic_info/system_settings" :class="{ on: selectedMenu == 'nav_li_system_settings' }">System Settings</router-link></li>
					<li v-if="user.super_admin_yn == 'Y'"><router-link to="/basic_info/global_settings" :class="{ on: selectedMenu == 'nav_li_global_settings' }">Global Settings</router-link></li>
				</ul>
			</div>
			<br />
			<br />
		</nav>
	</div>
</template>

<script>
import { apiSelectPartner } from '@/api/partner/index.js';

export default {
	data: function() {
		return {
			partner_code: null,
			//sideIndex: 0,
			//selectedMenu: '',
		};
	},
	props: ['stock_changed', 'headers'],
	computed: {
		//sideIndex: function() {
		//	return this.$store.sideIndex;
		//},
		selectedMenu: function() {
			return this.$store.getters['getSelectedMenu'];
		},
		sideIndex: function() {
			return this.$store.getters['getSideIndex'];
		},
		user: function() {
			//console.log(this.$session.get('user'));
			return this.$session.get('user');
		},
		profile: function() {
			return this.$session.get('profile');
		},
		menus: function() {
			return this.$session.get('menus');
		},
		fav_menus: function() {
			return this.$session.get('favMenus');
		},
		// visible: function() {s
		// 	return true;
		// },
		// keymap() {
		// 	return {
		// 		115: this.test,
		// 	};
		// },
	},
	watch: {
		sideIndex(newIndex, oldIndex) {
			//console.log(newIndex, oldIndex);
			if (newIndex != oldIndex) this.setAccorian();
		},
	},
	methods: {
		async gotoPartner(partner_code) {
			var param = {
				code: partner_code,
			};

			const { data } = await apiSelectPartner(param);
			if (!data.partner) {
				this.$toast.error('Not Found');
			} else {
				this.$router
					.push({
						name: 'partnerDetail',
						params: { mode: 'detail' },
						query: { backUri: this.uri, code: partner_code },
					})
					.catch(() => {});
			}
		},
		submenuCount(path) {
			//console.log('hmm', this.menus.filter(m => m.path.startsWith(path)).length);
			return this.menus.filter(m => m.path.startsWith(path)).length;
		},
		// test() {
		// 	console.log('test');
		// },
		visible(path) {
			for (var i = 0; i < this.menus.length; i++) {
				//console.log(menus[i]);
				if (this.menus[i].path == path && this.menus[i].view_yn == 'Y' && !this.menus[i].hide) return true;
			}
			return false;
		},
		setAccorian() {
			//console.log('setAccordian');
			//this.sideIndex = this.$store.sideIndex;
			//this.selectedMenu = this.$store.selectedMenu;
			//console.log(this.$store.selectedMenu);
			// 모든 화면이 렌더링된 후 실행합니다. });
			var si = this.sideIndex;
			if (si == 0) si = false;
			else si = si - 1;

			$('#left_accordian_nav').accordion({
				active: si,
				collapsible: true,
				heightStyle: 'content',
				header: 'h3',
				icons: false,
			});
		},
	},
	created() {},
	mounted() {
		this.$nextTick(function() {
			this.setAccorian();
			// this.sideIndex = this.$store.sideIndex;
			// //this.selectedMenu = this.$store.selectedMenu;
			// //console.log(this.$store.selectedMenu);
			// // 모든 화면이 렌더링된 후 실행합니다. });
			// if (this.sideIndex == 0) this.sideIndex = false;
			// else this.sideIndex = this.sideIndex - 1;
			// $('#left_accordian_nav').accordion({
			// 	active: this.sideIndex,
			// 	collapsible: true,
			// 	heightStyle: 'content',
			// 	header: 'h3',
			// 	icons: false,
			// });
		});
	},
};
</script>

<style scoped></style>
